import React, { useState } from "react";
import "./TalentCommunity.css";
// import PopupForm from "./CustomFormComponent";
// import config from "../config";


const TalentCommunity = () => {
  // const [isFormOpen, setIsFormOpen] = useState(false);

  // const openForm = () => setIsFormOpen(true);
  // const closeForm = () => setIsFormOpen(false);


  const sectionStyle = {
    // position: "relative",
    // width: "100%",
    // height: "300px",
    // backgroundImage: `url(${config.akinexplaceholder})`, 
    // backgroundSize: "cover",
    // backgroundPosition: "center top",
    // display: "flex",
    // justifyContent: "left",
    // alignItems: "center",
    // textAlign: "left",
  };

  return (
    <></>
    // <section className="talent-community-section" style={sectionStyle}>
    //   <div className="talent-content">
    //     <h2 className="talent-heading">Join Our Talent Pool.</h2>
    //     <p className="talent-description">
    //       Interested in becoming part of our dynamic team? Share your CV, and we’ll add you to our talent pool. We’ll notify you whenever there’s a job opening that matches your skills and expertise.
    //     </p>
    //     <button className="talent-btn"     onClick={() => {
    //             window.open("https://akinex.hoshihrms.com/liberation/103/REQUESTID/aFE9PQ", "_blank");
    //           // Ensure onClose is correctly called
    //           }}>Sign up</button>
    //   </div>

    //   {/* Render PopupForm when isFormOpen is true */}
    //   {/* <PopupForm jobTitle="General Application" isOpen={isFormOpen} onClose={closeForm} /> */}
    // </section>
  );
};

export default TalentCommunity;